import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const initialState = {
    isLoading: false,
    data: [],
    isError: false,
}

export const fetchSubscriptionPaymentList = createAsyncThunk('fetchSubscriptionPaymentList', async () => {
    const response = await fetch(`${API_BASE_URL}/subscription_payment/list`, {
        method: 'GET',
        headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
    });
    return response.json();
});

export const deleteSubscriptionPayment = createAsyncThunk('deleteSubscriptionPayment', async ({id}, {dispatch}) => {
    const details = {
        'payment_id': id,
    };

    let formBody = [];
    for (let property in details) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    
    const response = await fetch(`${API_BASE_URL}/subscription_payment/delete`, {
        method: 'POST',
        headers: { 
            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    });
    dispatch(fetchSubscriptionPaymentList());
    return response.json(); 
});

const subscriptionPaymentSlice = createSlice({
    name: 'subscriptionPayment',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchSubscriptionPaymentList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSubscriptionPaymentList.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.data) {
                state.data = action.payload.data;
            } else {
                state.isError = true;
            }
        });
        builder.addCase(fetchSubscriptionPaymentList.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default subscriptionPaymentSlice;